import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import * as actionsAlimentadores from '../../../store/alimentador/actions';
import { DialogDefaultV2, InputV2, SubestacaoSelectV2 } from '../../../components/v2';

const schema = {
  nome: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  codigo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  subestacaoIds: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const Formulario = ({ saveAlimentador, updateAlimentador, alimentadores, open, id, onClose }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (id) setValues(alimentadores.filter(a => a.id === id)[0]);
  }, [id, alimentadores]);

  const onSave = () => {
    const erros = validate(values, schema);
    setErrors(erros);
    if (!erros) {
      if (values.id) updateAlimentador(values);
      else saveAlimentador(values);
      onCloseLocal(true);
    }
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    setValues({});
    onClose(isSave);
  };

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Alimentador"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.codigo)}
            isRequired
            label="Código"
            name="codigo"
            onChange={handleChange}
            value={values.codigo || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 8 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.nome)}
            isRequired
            label="Nome"
            name="nome"
            onChange={handleChange}
            value={values.nome || ''}
          />
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
          <SubestacaoSelectV2
            error={!!(errors && errors.subestacaoIds)}
            isMultiple
            isRequired
            onSelect={subestacaoIds => setValues({ ...values, subestacaoIds })}
            value={values.subestacaoIds}
          />
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
          <InputV2
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao || ''}
            rows={4}
            multiline
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  saveAlimentador: PropTypes.func.isRequired,
  updateAlimentador: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  alimentadores: PropTypes.array.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsAlimentadores,
}, dispatch);

export default connect(null, mapDispatchToProps)(withRouter(Formulario));
